var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateRegistration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Update_Registration"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Update_Registration",
    "data-name": "Update Registration",
    clipPath: "url(#clip-Update_Registration)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11792",
    "data-name": "Group 11792",
    transform: "translate(1.257 1.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11793",
    "data-name": "Group 11793",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22253",
    "data-name": "Path 22253",
    d: "M0,31.685q0-2.2,0-4.394a1.381,1.381,0,0,1,1.314-1.319c1.861,0,3.721,0,5.582,0,.137,0,.172.042.164.171a3.614,3.614,0,0,0,0,.492c.009.128-.031.159-.158.159-1.063-.005-2.126,0-3.19,0H1.474a.6.6,0,0,0-.659.649q0,4.275,0,8.551a.531.531,0,0,0,.584.574q2.392,0,4.784,0a2.207,2.207,0,0,1,1,.208c.137.068.151.026.151-.1q0-2.57,0-5.141c0-.392,0-.392.394-.392.419,0,.419,0,.419.419q0,2.536,0,5.073c0,.2,0,.195.187.118a2.3,2.3,0,0,1,.887-.18q2.409,0,4.818,0c.438,0,.625-.187.625-.629q0-3.936,0-7.872c0-.159.043-.2.2-.19a3.506,3.506,0,0,0,.492,0c.116-.007.141.04.14.145,0,.65,0,1.3,0,1.951,0,2,0,3.993,0,5.989a1.343,1.343,0,0,1-.685,1.253,1.241,1.241,0,0,1-.647.167q-2.409,0-4.818,0a1.4,1.4,0,0,0-.922.27.639.639,0,0,0-.275.446.416.416,0,0,1-.381.331.421.421,0,0,1-.417-.31.945.945,0,0,0-.836-.7,2.133,2.133,0,0,0-.472-.034c-1.55,0-3.1-.009-4.649.006a1.358,1.358,0,0,1-1.367-1.1A1.528,1.528,0,0,1,0,35.994q0-2.155,0-4.309Z",
    transform: "translate(0 -22.965)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22254",
    "data-name": "Path 22254",
    d: "M59.777.778a.618.618,0,0,1-.249.513c-.1.075-.09.129-.018.213a.844.844,0,0,1,.229.351c.008.038.023.088.007.117-.125.214.036.347.128.5a1.537,1.537,0,0,1-.407,1.948c-.818.66-1.645,1.309-2.469,1.963-.266.211-.533.419-.8.633-.079.065-.13.086-.2-.015a4.126,4.126,0,0,0-.337-.424c-.081-.089-.075-.139.019-.213q1.015-.795,2.023-1.6c.395-.312.791-.622,1.183-.938a.76.76,0,0,0,.31-.861c-.016-.042-.042-.079-.062-.12-.058-.12-.122-.111-.219-.032q-2.746,2.227-5.5,4.45a.518.518,0,0,1-.255.116c-.652.108-1.3.228-1.954.344a.409.409,0,0,1-.473-.563c.246-.624.5-1.243.754-1.864a.552.552,0,0,1,.175-.224q2.25-1.816,4.5-3.635c.519-.419,1.039-.837,1.556-1.259.321-.263.516-.254.77.067.089.112.149.113.256.027a.59.59,0,0,1,.682-.051.646.646,0,0,1,.345.549M57.454,2.912l-.061-.078c-.184-.229-.373-.454-.551-.688-.075-.1-.125-.09-.213-.017-.343.285-.693.563-1.039.844-.773.626-1.544,1.254-2.319,1.876-.1.078-.108.127-.023.224.179.2.349.416.511.633.084.112.143.115.251.025.391-.326.789-.641,1.185-.961q1.088-.878,2.176-1.758c.032-.026.084-.04.083-.1M51.8,6.751a.239.239,0,0,0,.174.007c.281-.052.56-.114.843-.149a.736.736,0,0,0,.355-.211c.039-.03.027-.068,0-.1-.2-.249-.406-.5-.611-.747-.023-.028-.053-.069-.1-.034-.084.065-.2.11-.24.209-.147.34-.281.685-.42,1.029m6.331-4.364a.185.185,0,0,0,.029-.016l.541-.436c.059-.048.021-.09-.011-.13q-.3-.369-.6-.738c-.033-.041-.058-.076-.12-.023-.167.143-.341.279-.515.415-.05.039-.059.068-.015.122.206.248.407.5.61.749.02.025.034.062.077.057",
    transform: "translate(-44.844 0.001)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22255",
    "data-name": "Path 22255",
    d: "M21.5,73.524a.545.545,0,0,1-.287-.126q-.663-.593-1.333-1.177c-.068-.06-.088-.1-.014-.173.138-.141.268-.291.392-.445.065-.08.1-.069.173-.006.3.27.6.531.9.8.088.081.129.077.2-.023.472-.648.954-1.288,1.426-1.935.08-.109.136-.137.247-.04a4.556,4.556,0,0,0,.433.325c.074.051.082.089.028.161q-.916,1.228-1.828,2.46a.484.484,0,0,1-.336.178",
    transform: "translate(-17.531 -62.209)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22256",
    "data-name": "Path 22256",
    d: "M84.061,76.1c-.582,0-1.164,0-1.746,0-.118,0-.158-.03-.151-.15.01-.18.008-.362,0-.542,0-.091.017-.128.119-.128q1.78.005,3.559,0c.092,0,.129.024.125.122-.007.186-.011.373,0,.559.007.119-.041.137-.145.136-.587,0-1.175,0-1.763,0Z",
    transform: "translate(-72.664 -66.583)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22257",
    "data-name": "Path 22257",
    d: "M84.069,91.723c.582,0,1.164,0,1.745,0,.128,0,.165.036.157.161a4.047,4.047,0,0,0,0,.508c.007.118-.028.152-.149.151-.712-.006-1.423,0-2.135,0-.458,0-.915,0-1.373,0-.122,0-.154-.037-.148-.153a4.97,4.97,0,0,0,0-.525c-.006-.111.028-.143.14-.142.587.005,1.175,0,1.762,0",
    transform: "translate(-72.666 -81.115)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateRegistration);
export default __webpack_public_path__ + "static/media/Update Registration.2a8dd15baa95f35f7624a0358080c3ba.svg";
export { ForwardRef as ReactComponent };